<template>
<div>
  <HeaderGestion/>
  <SubHeaderGestion
    nombreGestion="Hemerografías"
  />
  <section class="Bdy">
    <FormHemero/>
  </section>
</div>
</template>

<script>
import FormHemero from '../components/FormHemero.vue'
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormHemero },
  name: 'GesHemero'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
